import { useMutation } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useUploadFile = () => {
  
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useMutation({
    mutationFn: async ({ file, path, startWith, fileName }) => {
      
      const formData = new FormData();
      formData.append('file', file);
      if (path) {
        formData.append('bucketPrefix', path);
      }
      if (startWith) {
        formData.append('startsWith', startWith);
      }
      if (fileName) {
        formData.append('fileName', fileName);
      }

      const result = await restClient({ 
        url: `${prefix}/upload`, 
        method: 'post',
        data: formData,
      });
      return result;
    },
    onSuccess: async () => {
    }
  });
};
